import React, { memo, useContext } from 'react';
import Svg from '../icons/svg';
import { Context } from '../../../context/global-data-provider';
import { rubikaProfileUrl } from '../../../func/rubika';

function ContactAdmin({ className, onClick: onElmClick }) {
  const { options } = useContext(Context);
  const profileUrl = rubikaProfileUrl(options?.rubika_admin);

  if (!(options?.rubika_admin && options?.rubika_admin_text && profileUrl)) return null;

  return (
    <>
      <div className={className}>
        <a href={profileUrl} target="_blank" rel="noopener noreferrer">
          <button
            className={'btn br-c-p w-100 bc-b-c d-flex align-items-center justify-content-center'}
            type="button"
            onClick={onElmClick}
          >
            <Svg name={'rubika'} fill={'#262626'} width={16} height={16} label={'Rubika'} />
            <span className="mr-8p font-size-5">{options.rubika_admin_text}</span>
          </button>
        </a>
      </div>
    </>
  );
}

export default memo(ContactAdmin);
